import {
  LOGIN_PATH,
  LOGIN_PATH_REGEX,
  ONBOARDING_QUERY_PARAM,
  REDIRECT_QUERY_PARAM,
  normalizeOnboardingQueryValue,
  normalizeRedirectTarget,
} from '../redirectTarget'
import { isPublicAdminPath, isProtectedAdminPath } from '../adminRouteGuard'

export const ensureLoginRedirect = (
  isAuthenticated: boolean,
  sessionBootstrapLoading = false,
) => {
  if (sessionBootstrapLoading) return
  if (isAuthenticated) return

  const currentPathname = window.location.pathname
  if (!isProtectedAdminPath(currentPathname) && !isPublicAdminPath(currentPathname)) {
    return
  }

  const isLoginPath = LOGIN_PATH_REGEX.test(currentPathname)
  if (!isLoginPath && isPublicAdminPath(currentPathname)) {
    return
  }
  const nextParams = new URLSearchParams()

  if (isLoginPath) {
    const currentParams = new URLSearchParams(window.location.search)
    const onboarding = normalizeOnboardingQueryValue(currentParams.get(ONBOARDING_QUERY_PARAM))
    if (onboarding) {
      nextParams.set(ONBOARDING_QUERY_PARAM, onboarding)
    }
    const existingRedirect = normalizeRedirectTarget(
      currentParams.get(REDIRECT_QUERY_PARAM),
      window.location.origin,
    )
    if (existingRedirect) {
      nextParams.set(REDIRECT_QUERY_PARAM, existingRedirect)
    }
  } else {
    const currentTarget = `${window.location.pathname}${window.location.search}${window.location.hash}`
    const redirectTarget = normalizeRedirectTarget(currentTarget, window.location.origin)
    if (redirectTarget) {
      nextParams.set(REDIRECT_QUERY_PARAM, redirectTarget)
    }
  }

  const query = nextParams.toString()
  const next = `${LOGIN_PATH}${query ? `?${query}` : ''}`
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`
  if (next !== current) {
    window.location.replace(next)
  }
}
